import axios from 'axios';

import config from '../../../../config/config';

const MainUrl = 'api/reports';

export const getDOCRawDataReports = () =>
  axios.get(`${MainUrl}/personMembership`, {
    baseURL: config.dutyOfCareApi.baseUrl,
    headers: { accept: 'text/csv' },
  });
